module.exports = __webpack_public_path__ + "img/check.5924203a.svg";